import React, { useRef } from 'react';
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import PropTypes from 'prop-types';

export default function Background({ pages }) {
  return (
    <ParallaxLayer offset={0} speed={0} factor={pages} style={{ backgroundImage: 'url("https://awv3node-homepage.surge.sh/build/assets/stars.svg")', backgroundSize: 'cover' }} />
  );
}